import {
  ChipDangerStyled,
  ChipPurpleStyled,
  ChipSuccessStyled,
  ChipWarningStyled,
} from './status-chip.styled';

interface Props {
  label: string;
  variant: 'success' | 'danger' | 'warning' | 'purple';
  attrs?: {
    size?: 'small' | 'medium';
  };
}

export const StatusChip = ({ label, variant, attrs: { size } = {} }: Props) => {
  switch (variant) {
    case 'success':
      return <ChipSuccessStyled>{label}</ChipSuccessStyled>;
    case 'danger':
      return <ChipDangerStyled>{label}</ChipDangerStyled>;
    case 'warning':
      return <ChipWarningStyled attrs={{ size }}>{label}</ChipWarningStyled>;
    case 'purple':
      return <ChipPurpleStyled attrs={{ size }}>{label}</ChipPurpleStyled>;
  }
};
